import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminCompetitorScrape from "@/pages/admin/AdminCompetitorScrape";

export const Route = createFileRoute("/admin/competitor")({
  component: () => (
    <ProtectedRoute>
      <AdminCompetitorScrape />
    </ProtectedRoute>
  ),
});
